export enum SiteIssues {
    MissingRecords = 1,
    OwnerMismatch,
    OwnerValid
}